// app/javascript/projects/components/ProjectsDisplay.jsx

import React, {useCallback, useContext} from 'react';
import { Button } from 'ui'
import Excerpt from './Excerpt'
import CodeabeleContext from 'contexts/CodeableContext';
import CodeOperationsContext from 'contexts/CodeOperationsContext';

const LEFT_PADDING = 45;

function ExcerptListComponent({
  codePage,
  projectID,
  excerptIds, // Changed from excerpts to excerptIds
  headerText,
  hasEditPermission,
  onLinkClick,
  onCodeClick,
  showMore,
  loading,
  canPage
}) {
  const {
    selectedExcerptId,
    onDeselect
  } = useContext(CodeabeleContext);
  
  const {
    onExcerptSelected
  } = useContext(CodeOperationsContext);

  const onClick = useCallback((e) => {
    onDeselect();
    // make sure does not bubble up
    e.stopPropagation();
  })

  const selectedExcerptIdString = selectedExcerptId ? selectedExcerptId.toString() : null;

  const excerptComponents = (excerptIds || []).map((excerptId, index) => {
    return(
          <Excerpt
            codePage={codePage}
            projectID={projectID}
            excerptId={excerptId} // Pass ID instead of full excerpt
            key={excerptId} // Better to use actual ID as key
            onLinkClick={onLinkClick}
            onTextClicked={onExcerptSelected}
            selected={excerptId?.toString() === selectedExcerptIdString}
            hasEditPermission={hasEditPermission}
            onCodeClick={onCodeClick}
            />
        );
  });

  return (
    <div style={{padding:`20px ${LEFT_PADDING}px`}}
      onClick={onClick}
    >
      {headerText ? (
        <span style={{fontSize:'.8em', cursor:'default'}}><strong>
          {headerText}
        </strong></span>
      ) : null}
      {excerptComponents}

      {canPage &&
        <div style={{textAlign:'center', marginBottom:"20px"}}>
          <Button variant="white"
            onClick={showMore}
            disabled={loading}
            >Show More</Button>
        </div>
      }
    </div>
  );
}

export default ExcerptListComponent;
